<template>
    <div class="custom-modal"
         @click="closeCustomModal()">

        <div class="custom-modal-window" style="min-height: 750px;" @click.stop>
            <div class="btn-close" @click="closeCustomModal()"></div>

            <div v-if="fetcher.initialized">

                <h2 v-if="employee.name != ''">#{{ employee.id }} {{ employee.name }}</h2>
                <h2 v-else>Lägg till anställd</h2>

                <div class="row mb-4">
                    <div class="col-12 col-sm-5 col-xl-4">
                        <p class="mb-0">
                            <b>Registrerad/skapad</b><br>
                            {{ employee.created_at }}
                        </p>
                    </div>
                    <div class="col-12 col-sm-5 col-xl-3" v-if="employee.invited_at">
                        <p class="mb-0">
                            <b>Inbjuden</b><br>
                            {{ employee.invited_at }}
                        </p>
                    </div>
                    <div class="col-12 col-sm-5 col-xl-3">
                        <p class="mb-0">
                            <b>Aktiverad</b><br>
                            {{ employee.activated_at }}
                        </p>
                    </div>
                </div>

                <div class="tabs-container tabs-grey">

                    <div class="tab" :class="{ 'active' : activeTab === 'employee-modal-info' }"
                         @click="loadView('employee-modal-info')">Uppgifter
                    </div>
                    <div class="tab"
                         :class="{ 'active' : activeTab === 'employee-modal-punch' }"
                         @click="loadView('employee-modal-punch')"
                         v-if="employee.company.has_active_contract && employee.activated_at"
                    >
                        Registrera behandling
                    </div>
                    <div class="tab" :class="{ 'active' : activeTab === 'employee-modal-treatments' }"
                         @click="loadView('employee-modal-treatments')">Behandlingar
                    </div>
                    <div class="tab" :class="{ 'active' : activeTab === 'employee-modal-misc' }"
                         @click="loadView('employee-modal-misc')">Hantera konto
                    </div>

                </div>

                <div style="padding-top:24px; min-height: 600px;">

                    <employee-modal-info
                        :employee="employee"
                        :workplaces="workplaces"
                        :dynamic_fields="dynamic_fields"
                        v-if="activeTab === 'employee-modal-info'"
                        @refresh="refresh()"
                        @createNew="createNew()"
                        :key="'i'+employee.updated_at"
                    />
                    <employee-modal-punch
                        :employee="employee"
                        :clinics="clinics"
                        :first_creatable_treatment_date="first_creatable_treatment_date"
                        v-if="activeTab === 'employee-modal-punch' && employee.company.has_active_contract"
                    />
                    <h2 v-if="activeTab === 'employee-modal-punch' && !employee.company.has_active_contract">Företaget saknar aktivt avtal</h2>

                    <employee-modal-treatments
                        :employee="employee"
                        v-if="activeTab === 'employee-modal-treatments'"
                    />
                    <employee-modal-misc
                        :employee="employee"
                        v-if="activeTab === 'employee-modal-misc'"
                        @refresh="refresh()"
                        @close="closeCustomModal(true)"
                    />

                </div>

            </div>

            <div class="modal-loader" style="width:100%;" v-else>

                <h2>Laddar...</h2>

                <div class="row mb-4">
                    <div class="col-12 col-sm-5 col-xl-4">
                        <p class="mb-0">
                            <b>Registrerad/skapad</b><br>
                            <span style="color:#fff;">.</span>
                        </p>
                    </div>
                    <div class="col-12 col-sm-5 col-xl-3">
                        <p class="mb-0">
                            <b>Aktiverad</b><br>
                        </p>
                    </div>
                </div>

                <div class="tabs-container tabs-grey">

                    <div class="tab active">
                        Uppgifter
                    </div>
                    <div class="tab">
                        Registrera behandling
                    </div>
                    <div class="tab">
                        Behandlingar
                    </div>
                    <div class="tab">
                        Hantera konto
                    </div>

                </div>

                <div class="w-100 d-flex justify-content-center align-items-center" style="min-height: 400px;">

                    <div class="spinner-border text-info" style="color:#999!important;" role="status"></div>

                </div>

            </div>

        </div>
    </div>

</template>

<script>
import employeeModalInfo from './modal-info.vue'
import employeeModalPunch from './modal-punch.vue'
import employeeModalTreatments from './modal-treatments.vue'
import employeeModalMisc from './modal-misc.vue'

import fetcher from '../../../../shared/mixins/fetcher'
import modaler from '../../../../shared/mixins/modaler'

export default {

    mixins: [
        fetcher,
        modaler
    ],

    components: {
        employeeModalInfo,
        employeeModalPunch,
        employeeModalTreatments,
        employeeModalMisc
    },

    props: {
        employee_id: {
            required: true
        },
        tab: {}
    },

    data () {
        return {
            activeTab: this.tab ?? 'employee-modal-info',
            employee: null,
            last_treatment_at: null,
            num_treatments: 0,
            workplaces: [],
            clinics: [],
            first_creatable_treatment_date: null,
            dynamic_fields: [],
            fetcher: {
                autoFill: [
                    'employee',
                    'last_treatment_at',
                    'num_treatments',
                    'workplaces',
                    'dynamic_fields',
                    'clinics',
                    'first_creatable_treatment_date'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/employees/' + this.employee_id
        }
    },

    methods: {

        loadView (name) {
            this.activeTab = name
        },

        refresh () {
            this.fetcherFetch()
            this.$emit('refresh')
        },

        createNew () {
            console.log('asd')
            this.$emit('close')
            this.$emit('createNew')
        }

    }

}
</script>
